import { defineMessages } from 'react-intl';

export default defineMessages({
    documentError: {
        id: '_.draw_down.sign_documents.unable_to_get_documents',
        defaultMessage:
            'We were unable to complete the signing documents process. Your account manager will be in contact soon, or give us a call on this number 020 3778 0105.'
    },
    sign: {
        id: '_.draw_down.sign_documents.sign',
        defaultMessage: 'Sign'
    },
    cancel: {
        id: '_.draw_down.sign_documents.cancel',
        defaultMessage: 'Cancel'
    },
    pleaseReadToSign: {
        id: '_.draw_down.sign_documents.please_read_to_sign',
        defaultMessage:
            'Please read to the bottom of the agreement and click "sign" to continue.'
    },
    mlaTermsAgreement: {
        id: '_.draw_down.sign_documents.mla_terms_agreement',
        defaultMessage:
            'Ich habe den Darlehensvertrag gelesen und stimme den {link} zu'
    },
    mlaTermsAgreementTermsAndConditions: {
        id: '_.draw_down.sign_documents.mla_terms_and_conditions',
        defaultMessage: 'Allgemeinen Geschäftsbedingungen'
    }
});
